import React from "react";
import { useNavigate } from "react-router-dom";
import Homebanner from "./saloonhome/Homebanner";
import AffordableHome from "./saloonhome/AffordableHome";
import BeautySlider1 from "./saloonhome/BeautySlider1.jsx";
import MobileHeader from "../components/layout/MobileHeader.jsx";
import GenericSalon from "./saloonhome/GenericSalon.jsx";

export function Saloonhome() {
  const navigate = useNavigate();

  const salonConfigs = [
    {
      salonType: "Female",
      title: "Salon for Female",
      useReduxSelector: false,
      fetchFromApi: true,
    },
    {
      salonType: "Male",
      title: "Salon for Male",
      useReduxSelector: false,
      fetchFromApi: true,
    },
    // {
    //   salonType: "Pet",
    //   title: "Salon for Pet",
    //   useReduxSelector: false,
    //   fetchFromApi: true,
    // },
  ];

  return (
    <div style={{backgroundColor:"#f5f6fb"}} className="py-4">
      <div id="saloonHome">
        <Homebanner />

        <div className=" mt-4" style={{backgroundColor:"#f5f6fb"}}>
          {/* Render all salon components from config */}
          {salonConfigs.map((config, index) => (
            <GenericSalon key={`${config.salonType}-${index}`} {...config} />
          ))}

          <AffordableHome />
          {/* <BeautySlider1 /> */}
        </div>
      </div>
    </div>
  );
}
